<svg width="12" height="10" viewBox="0 0 12 10" xmlns="http://www.w3.org/2000/svg">
<path d="M1 1L11 1" strokeWidth="2" stroke-linecap="round"/>
<path d="M1 5L11 5" strokeWidth="2" stroke-linecap="round"/>
<path d="M1 9L11 9" strokeWidth="2" stroke-linecap="round"/>
</svg>
